import { AdobeAnalyticsConst } from './adobeAnalyticsConstants/adobeAnalyticsConstants';

interface AuthCheckAnalyticsDetails {
  attempts?: number;
}

// Deliberately omits url/path/pageTitle: these auth-check events fire at the app-entry URL, which in a
// healthcare context can carry PII (an HCP name in ?searchFor=, a UCI/identifier, OAuth code/state, or an
// HCP name in the document title). Only PII-free context is emitted.
export const getAuthCheckAnalyticsPayload = (event: string, details: AuthCheckAnalyticsDetails = {}) => ({
  event,
  timestamp: Date.now(),
  page: {
    siteName: AdobeAnalyticsConst.SITE_DETAILS.name,
    language: window.navigator?.language || 'en',
    domain: window.location?.hostname ?? '',
  },
  details,
});
